// @mui
import { alpha } from '@mui/material/styles';
import { Box, Grid, Stack, Typography } from '@mui/material';
// components
import Iconify from '../../../components/iconify';
import { ConsultForm } from '../contact';

// ----------------------------------------------------------------------

const SUPPORT_POINTS = [
  'Course and exam pathway guidance',
  'Online and classroom learning options',
  'A response from the ASAP support team',
];

export default function ContactFormWidget() {
  return (
    <Box
      component="section"
      aria-labelledby="consultation-heading"
      sx={{
        position: 'relative',
        isolation: 'isolate',
        overflow: 'hidden',
        borderRadius: 3,
        my: { xs: 5, md: 8 },
        px: { xs: 2, sm: 3, md: 5 },
        py: { xs: 3, sm: 4, md: 5 },
        backgroundColor: 'grey.900',
        backgroundImage: 'url(/assets/images/asap/banner_02.jpg)',
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        '&::before': {
          content: "''",
          position: 'absolute',
          inset: 0,
          zIndex: -1,
          background: (theme) =>
            `linear-gradient(110deg, ${alpha(theme.palette.grey[900], 0.96)} 0%, ${alpha(
              theme.palette.grey[900],
              0.84
            )} 58%, ${alpha(theme.palette.primary.dark, 0.78)} 100%)`,
        },
      }}
    >
      <Grid container spacing={{ xs: 3, md: 5 }} sx={{ alignItems: 'center' }}>
        <Grid size={{ xs: 12, md: 6 }}>
          <Typography
            variant="subtitle2"
            sx={{ color: 'primary.light', textTransform: 'uppercase', letterSpacing: 1.2, mb: 1.25 }}
          >
            Free consultation
          </Typography>

          <Typography
            id="consultation-heading"
            component="h2"
            variant="h3"
            sx={{ color: 'common.white', maxWidth: 560, mb: 2 }}
          >
            Find the right route for your licensing journey
          </Typography>

          <Typography
            variant="body1"
            sx={{ color: (theme) => alpha(theme.palette.common.white, 0.76), lineHeight: 1.8, maxWidth: 560 }}
          >
            Tell us which exam, course or licensing service you need help with. Our team will review your enquiry and
            contact you to discuss the next step.
          </Typography>

          <Stack spacing={1.25} sx={{ mt: 3 }}>
            {SUPPORT_POINTS.map((point) => (
              <Stack key={point} direction="row" spacing={1.25} sx={{ alignItems: 'center' }}>
                <Box
                  sx={{
                    width: 28,
                    height: 28,
                    flexShrink: 0,
                    borderRadius: '50%',
                    display: 'grid',
                    placeItems: 'center',
                    color: 'common.white',
                    bgcolor: (theme) => alpha(theme.palette.primary.main, 0.75),
                  }}
                >
                  <Iconify icon="eva:checkmark-fill" width={17} />
                </Box>
                <Typography variant="body2" sx={{ color: 'common.white' }}>
                  {point}
                </Typography>
              </Stack>
            ))}
          </Stack>
        </Grid>

        <Grid size={{ xs: 12, md: 6 }}>
          <Box sx={{ maxWidth: 560, ml: { md: 'auto' } }}>
            <ConsultForm
              title="Request a consultation"
              subtitle="Share your details and what you would like help with."
            />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}
